/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoFssIcon16Light = forwardRef('GovKoFssIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 .5a.5.5 0 0 0-1 0v1.019A6.5 6.5 0 0 0 7 14.48V15.5a.5.5 0 0 0 1 0v-1.019A6.5 6.5 0 0 0 8 1.519V.5ZM7 2.522a5.5 5.5 0 0 0 0 10.956v-1.056a4.45 4.45 0 0 1 0-8.844V2.522Zm0 1.963a3.55 3.55 0 0 0 0 7.03V10.4a2.45 2.45 0 0 1 0-4.8V4.485Zm0 2.047a1.551 1.551 0 0 0 0 2.936V6.532Zm1 6.946V2.522a5.5 5.5 0 0 1 0 10.956Z" })));
});
